import React from "react";

import { cn } from "../../../common/u1/cn";
import { Button } from "../../../common/u1/Button";
import { ChevronRight, ChevronDown } from "../../../../assets/ui/icons";
import { MEASURE } from "./editLayout";

/* The action bar pinned under every section. */
export const EditFooterBar = ({
  onBack,
  onSkip,
  onContinue,
  isLoading = false,
  continueLabel = "Save & Continue",
  skipLabel = "Skip for now",
  className = "",
}) => (
  <div
    className={cn(
      "w-full shrink-0 border-t border-[var(--line)] bg-white pt-3.5",
      /* Pinned to the bottom of the viewport, so on a phone the home bar
         would otherwise sit over these buttons. Same treatment as
         MobileTabBar. */
      "pb-[calc(0.875rem+env(safe-area-inset-bottom,0px))]",
      className
    )}
  >
    {/* The same measured column as the form above, so the buttons land on the
        card's edges rather than the viewport's. */}
    <div className={cn(MEASURE, "flex flex-wrap items-center justify-between gap-3")}>
      {/* Left cell is held even with no Back button so the right-hand pair does
          not shift between sections. */}
      <div className="min-w-0">
        {onBack && (
          <Button variant="ghost" onClick={onBack} className="gap-2">
            {/* No dedicated left chevron in the shared set; the down chevron
                rotated is the same mark and keeps the set from growing a
                near-duplicate. */}
            <ChevronDown size={12} className="rotate-90" />
            Go Back
          </Button>
        )}
      </div>

      <div className="flex flex-wrap items-center gap-3">
        {onSkip && (
          <Button variant="outline" onClick={onSkip}>
            {skipLabel}
          </Button>
        )}

        <Button
          variant="coralSolid"
          onClick={onContinue}
          disabled={isLoading}
          className="gap-2"
        >
          {isLoading ? "Saving…" : continueLabel}
          {!isLoading && <ChevronRight size={12} />}
        </Button>
      </div>
    </div>
  </div>
);

export default EditFooterBar;
